import React, { memo } from 'react';
import {useState} from 'react';
import { Handle } from 'react-flow-renderer';

import call from '../img/call.png'
import DesignCard from './DesignCard';
import CallIcon from '@material-ui/icons/SettingsEthernetTwoTone';


export default memo(({ data }) => {

    
  const designerIconStyle = {
    // backgroundImage:'linear-gradient(to bottom, grey, royalblue)', color:'white', borderRadius:'15px', marginLeft:'10px'
    padding:'0px', color:'royalblue', borderRadius:'20px', marginTop:'10px', marginLeft:'10px', marginRight:'10px'
  }

    return (
    <div className='designnode'>
      <Handle
        type="target"
        position="top"
        style={{ background: '#555' }}
        onConnect={(params) => console.log('handle onConnect', params)}
      />
      {/* <img draggable={false} src={call} width='50' height='50'></img> */}
      <CallIcon fontSize='large' style={designerIconStyle} draggable={false}/>
      <DesignCard attributes={data.attributes} name={data.label}/>

      <Handle
        type="source"
        position="bottom"
        id="b2"
        style={{ bottom: -5, top: 'auto', background: '#555' }}
      />
    </div>
  );
});